import ninegrid from "../index.js";

class ngMaxPopup extends HTMLElement
{
	#owner;
	#grd;
	
	constructor() {
	
		super();

		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");

		this.shadowRoot.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/ninegrid.css";
				:host {
				}
				nine-grid {
					height: 100% !important;
					width: 100% !important;
				}
			</style>
			
			<nx-dialog>
				${this.#owner.originFormat}
			</nx-dialog>
		`;
		
		this.#grd = this.shadowRoot.querySelector("nine-grid");
		this.#grd.removeAttribute("display-row-count");
		//this.#grd.removeAttribute("onload");
		//$(this.#grd).css({"width": "100% !important", "height": "100% !important",});

		$(".reset", this.shadowRoot).on("click", e => {
			this.#grd.data.assign(this.#owner.data.get());
		});
		
		$(".apply", this.shadowRoot).on("click", e => {

			var changedData = this.#grd.data.getChangedData();

			this.#owner.data.add(changedData.insert);
				
			for (var o of changedData.update) {
				this.#owner.data.update(o);
			}

			for (var o of changedData.delete) {
				this.#owner.data.delete(o);
			}
			
			this.#grd.data.changeRowState();
		});
		
		//$(".close", this.shadowRoot).onFirst("click", e => {
		this.shadowRoot.addEventListener("click", e => {
			if (!this.#grd.data.isChanged()) return;

			e.stopImmediatePropagation();
			
			ninegrid.confirm("There is changed data.\nDo you want to save it?", "SAVE", {"class": "rgb", "true-text": "Yes", "false-text": "No", }).then(result => {

				if (result) {
					$(".apply", this.shadowRoot).trigger("click");
				}
				
				this.shadowRoot.querySelector("nx-dialog").close();
			});
		});
		//this.#init();
	}
	
	popup = () => {
		setTimeout(() => {
			/** 생성 즉시 호출시 오류 (this.#grd.data null) */
			this.#grd.data.assign(this.#owner.data.get());
			this.shadowRoot.querySelector('dialog').showModal();
		}, 100);
	};
}

if (!customElements.get('ng-max-popup')) {
	customElements.define("ng-max-popup", ngMaxPopup);
}

